import React from 'react';

export const HTMLContent = ({content, className=''}) => {
   if(content)
   return <div className={className} dangerouslySetInnerHTML={{__html: content}}/>
   else return null
}
export const H1Content = ({content, className=''}) => {
   if(content)
   return <h1 className={className} dangerouslySetInnerHTML={{__html: content}}/>
   else return null
}

